import { IOnInit } from "angular";
import {
  ContractTypeService,
  IContractTab,
} from "../../shared/ContractService";
import { Record } from "../../../records/server/crud";

export class ContractDetailsViewController implements IOnInit {
  readonly contract!: Record;
  readonly contractType!: ContractTypeService;

  constructor() {}

  $onInit(): void {}

  getTabs() {
    return this.contractType.tabs ?? [];
  }

  getTabSref(tab: IContractTab) {
    return this.contractType.infoSref(tab);
  }
}
